import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";
import { usePageMeta } from "../hooks/usePageMeta";

const SECTIONS = [
    {
        title: "1. Information We Collect",
        body: "When you submit an inquiry through our website, we collect the information you provide: your name, email address, country, organization (optional), area of interest and message. We also collect standard technical information such as browser type and pages visited for analytics purposes.",
    },
    {
        title: "2. How We Use Your Information",
        body: "We use the information you provide to respond to your inquiry, to understand interest in our platform, and to develop our healthcare ecosystem partnerships. We do not sell your personal information to third parties.",
    },
    {
        title: "3. Medical Information",
        body: "GoMedVoyage is a healthcare navigation and facilitation platform and does not itself provide medical diagnosis or treatment. Please do not submit detailed medical records through this website's inquiry forms. Any future handling of medical information will be governed by separate, explicit consent mechanisms.",
    },
    {
        title: "4. Data Security",
        body: "We apply strong privacy, security and consent principles in the handling of personal information. Access to inquiry data is restricted to authorized team members and protected through technical and organizational measures.",
    },
    {
        title: "5. Data Retention",
        body: "We retain inquiry information only for as long as necessary to respond to you and to develop our partnership ecosystem, after which it is securely deleted or anonymized.",
    },
    {
        title: "6. Your Rights",
        body: "You may request access to, correction of, or deletion of your personal information at any time by contacting us through our contact page.",
    },
    {
        title: "7. Changes to This Policy",
        body: "We may update this Privacy Policy as our platform evolves. The current version will always be available on this page.",
    },
];

export default function PrivacyPage() {
    usePageMeta("Privacy Policy | GoMedVoyage", "How GoMedVoyage collects, uses and protects your information.");
    return (
        <div data-testid="privacy-page">
            <Header />
            <main className="pt-40 pb-28 bg-white">
                <div className="max-w-3xl mx-auto px-6 lg:px-8">
                    <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand-green">Legal</p>
                    <h1 data-testid="privacy-headline" className="mt-6 font-heading text-4xl sm:text-5xl font-bold tracking-tighter text-brand-blue">Privacy Policy</h1>
                    <p className="mt-4 text-sm text-slate-500">Last updated: July 2026</p>
                    <div className="mt-12 space-y-10">
                        {SECTIONS.map((s) => (
                            <section key={s.title}>
                                <h2 className="font-heading text-xl font-semibold text-brand-blue">{s.title}</h2>
                                <p className="mt-3 text-base leading-relaxed text-slate-600">{s.body}</p>
                            </section>
                        ))}
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
}
